'use client';

import { datadogRum } from '@datadog/browser-rum';

import getEnvironmentVariables from '@/server/utils/getEnvironmentVars';

/**
 * Initializes datadog RUM. Only runs on the client.
 */
(function initializeDatadogRum() {
  if (typeof window === 'undefined') {
    return;
  }

  const envVars = getEnvironmentVariables([
    'NEXT_PUBLIC_APP_ENV',
    'NEXT_PUBLIC_DATADOG_APPLICATION_ID',
    'NEXT_PUBLIC_DATADOG_CLIENT_TOKEN',
    'NEXT_PUBLIC_APP_DOMAIN',
    'NEXT_PUBLIC_GIT_TAG',
    'NEXT_PUBLIC_GIT_SHA'
  ]);

  if (envVars.isErr()) {
    console.error('Unable to start datadog RUM.', envVars.error.cause);

    return;
  }

  const {
    NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    NEXT_PUBLIC_APP_DOMAIN,
    NEXT_PUBLIC_GIT_TAG,
    NEXT_PUBLIC_GIT_SHA
  } = envVars.value;

  // During local development, we don't want to initialize datadog RUM
  if (NEXT_PUBLIC_APP_ENV === 'local') {
    return;
  }

  datadogRum.init({
    applicationId: NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'myomers-phoenix',
    env: NEXT_PUBLIC_APP_ENV,
    version: NEXT_PUBLIC_GIT_TAG || NEXT_PUBLIC_GIT_SHA,
    traceSampleRate: 100,
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    allowedTracingUrls: [`https://${NEXT_PUBLIC_APP_DOMAIN}`],
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: NEXT_PUBLIC_APP_ENV !== 'prod',
    // Please do not modify defaultPrivacyLevel value, reach out to devops
    // for change ticket and approval from senior VP of pensions services
    defaultPrivacyLevel: 'mask'
  });

  if (NEXT_PUBLIC_APP_ENV !== 'prod') {
    datadogRum.startSessionReplayRecording();
  }
})();
